module.exports = "pegasus/assets/blocks/column-15-theme3.png";